import {createTheme} from '@mui/material/styles/index.js';
import {LIGHT_THEME as planetTheme} from '@apps-common/ui-theme/Themes';

export const theme = createTheme(planetTheme, {
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        'html, body, #root': {
          height: '100%',
          backgroundColor: planetTheme.palette.background.paper,
        },
        '#root': {
          display: 'flex',
          flexDirection: 'column',
        },
      },
    },
    '& .MuiFormControlLabel-root': {
      styleOverrides: {
        label: {
          fontSize: 14,
        },
      },
    },
  },
});
